/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".source-modal{text-align:center}.source-modal .ig-row{padding:8px 0}.source-modal .ig-row ig-col{text-align:left}.source-modal .main-icon{color:#ccc}.source-modal .title{font-size:20px;font-weight:700;text-align:left;padding-bottom:8px;border-bottom:2px solid #0e76e6;text-transform:uppercase}.source-modal p{padding:8px 0;text-align:left;font-weight:700}.source-modal ig-field input{width:calc(100% - 42px)}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/event.pulling.status/event.pulling.status.modal.component.scss.ngstyle.js.pre-build-optimizer.js